module.exports = __webpack_public_path__ + "img/host3.ea02084b.png";